import ViewPager from "@react-native-community/viewpager";

export const Pager = ViewPager;